import BottomSheet from "components/common/BottomSheet";
import "./within3DaysNotification.scss";
const Within3DaysNotification = ({ isOpen, onClose, onContinue }) => {
    return (
        <BottomSheet
            isOpen={isOpen}
            onClose={onClose}
            title="꼭 확인해주세요."
            className="within-3-days-notification"
        >
            <div className="within-3-days-notification-content">
                <p>수업 시작일 기준 3일 이내에 예약한 경우 취소가 불가합니다</p>
                <p>
                    단, 예약 완료 시점으로부터 10분 이내에 한하여 취소
                    가능합니다.
                </p>
                <button
                    className="btn btn-purple500 btn-full btn-giant"
                    onClick={onContinue}
                >
                    계속 예약하기
                </button>
            </div>
        </BottomSheet>
    );
};

export default Within3DaysNotification;
